import React from 'react';

import ReactPlayer from 'react-player/lazy';

import Slider from 'react-slick';
import Image from 'next/image';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute" style={{ top: '50%', right: '-23px', transform: 'translateY(-50%)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

var settings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  dotsClass: 'custom-dots',
  // prevArrow:<span><img src="/images/icons/arrow-left-purple.svg"></img></span>,
  waitForAnimate: true,
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        arrows: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
      },
    },
  ],
};

export default class AsNavFor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });
  }

  render() {
    return (
      <div className="md:grid grid-cols-10">
        <div className="col-span-3 flex flex-col justify-center">
          <div>
            <Slider
              asNavFor={this.state.nav1}
              ref={slider => (this.slider2 = slider)}
              slidesToShow={1}
              swipeToSlide={true}
              focusOnSelect={true}
              speed={0}
              arrows={false}
              infinite={true}
              waitForAnimate={true}
            >
              {this.props.texts.map((text, index) => (
                <div key={index}>
                  <p className="text-16 md:text-24 text-black font-bold leading-none">{text}</p>
                  {this.props.links && (
                    <a
                      href={this.props.links[index]}
                      className="bg-green hover:bg-purple hidden md:inline-block transition-all transition-400 text-white mt-10 px-23 py-10 text-16 rounded-md"
                    >
                      More Examples
                    </a>
                  )}
                  {!this.props.links && (
                    <a
                      href="https://weprodigi.com/main/cases?filtersList=socialMediaAssets"
                      className="bg-green hover:bg-purple hidden md:inline-block transition-all transition-400 text-white mt-10 px-23 py-10 text-16 rounded-md"
                    >
                      More Examples
                    </a>
                  )}
                </div>
              ))}
            </Slider>

            {/* <p className="text-24 text-black font-bold mb-15">Cornwall Laser<br></br>Clinic</p> */}
          </div>
        </div>

        <div className="col-span-7">
          <div className="pr-0 md:pr-23">
            <Slider asNavFor={this.state.nav2} ref={slider => (this.slider1 = slider)} {...settings}>
              {this.props.images.map((item, index) => (
                <div key={index} className="focus:outline-none">
                  <div className="w-full max-w-320 md:max-w-md pr-5">
                    {item.type == 'image' ? (
                      <img width={item.width || 400} height={item.height || 549} src={item.src} layout="intrinsic" alt={item.type} />
                    ) : (
                      <div className="relative w-full" style={{ paddingBottom: item.width ? (item.height / item.width) * 100 + '%' : '137%' }}>
                        {/* <ReactPlayer className="absolute w-full h-full left-0 top-0" url={item.src} muted autoPlay loop playsInline></ReactPlayer> */}

                        <video className="absolute w-full h-full left-0 top-0" src={item.src} muted autoPlay loop playsInline></video>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="text-right w-full">
            <a
              href="https://weprodigi.com/main/cases?filtersList=socialMediaAssets"
              target="_blank"
              className="bg-green hover:bg-purple md:hidden inline-block  transition-all transition-400 text-white mt-15 px-23 py-10 text-16 rounded-md"
            >
              More Examples
            </a>
          </div>
        </div>
        <style jsx global>{`
          .custom-dots {
            display: flex !important;
            justify-content: center;
          }
          .custom-dots li {
            position: relative;
            margin: 0 3px;
            width: 50px;
            height: 2px;
            background-color: #c4c4c4;
            overflow: hidden;
          }
          .custom-dots li.slick-active {
            background-color: #670f7a;
          }
          .custom-dots li button {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            //display:none;
          }
        `}</style>
      </div>
    );
  }
}
